import script from "./AllSyncOps.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllSyncOps.vue?vue&type=script&setup=true&lang=ts"

import "./AllSyncOps.vue?vue&type=style&index=0&id=2109f046&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2109f046"]])

export default __exports__